import { Flex } from '@banhala/ui-kit';
import { useGridStyle } from '../../hooks/useGridStyle';
import type { ReactNode } from 'react';

export const RectangleFilterItem = ({
  isSelected,
  children,
  onPress,
}: {
  isSelected: boolean;
  children: ReactNode;
  onPress?: VoidFunction;
}) => {
  const { GRID_ITEM_WIDTH } = useGridStyle();

  return (
    <Flex.Row
      alignItems="center"
      width={GRID_ITEM_WIDTH}
      padding={{ horizontal: 14, vertical: 14 }}
      borderColor={isSelected ? 'border_black_primary' : 'border_tertiary'}
      borderWidth={1}
      borderRadius={4}
      onPress={onPress}
    >
      {children}
    </Flex.Row>
  );
};
